import React from 'react';
import AddServicePlanForm from '../../../../components/ServicePlanManagement/AddServicePlanForm';

const AddServicePlan = ({ }) => {
    const initialValues = {
        userType: 'renter',
        aiFeaturesStatus: "true",
    };
    return (
        <AddServicePlanForm initialValues={initialValues} />
    )
}

export default AddServicePlan;
